import React from 'react';
import { FiX, FiGithub, FiFacebook, FiInstagram } from 'react-icons/fi';
import qr from './assets/qr.jpg';

const DonateModal = ({ isOpen, onClose }) => {
  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 bg-black bg-opacity-75 flex items-center justify-center z-50">
      <div className="bg-gray-900 p-8 rounded-lg max-w-md w-full">
        <div className="flex justify-between items-center mb-4">
          <h2 className="text-2xl font-bold text-white">Buy Me a Coffee</h2>
          
          <button 
            onClick={onClose} 
            className="text-white hover:text-gray-300"
          >
            <FiX className="w-6 h-6" />
          </button>
        </div>
        <div className="flex justify-center mb-6">
          <img 
            src={qr} 
            alt="Support" 
            className="h-48 rounded-md"
          />
        </div>
        <div className="flex justify-center space-x-4">
          <a 
            href="https://github.com/yourusername" 
            target="_blank" 
            rel="noopener noreferrer"
            className="text-white hover:text-gray-300"
          >
            <FiGithub className="w-8 h-8" />
          </a>
          <a 
            href="https://facebook.com/yourprofile" 
            target="_blank" 
            rel="noopener noreferrer"
            className="text-white hover:text-gray-300"
          >
            <FiFacebook className="w-8 h-8" />
          </a>
          <a 
            href="https://instagram.com/yourprofile" 
            target="_blank" 
            rel="noopener noreferrer"
            className="text-white hover:text-gray-300"
          >
            <FiInstagram className="w-8 h-8" />
          </a>
        </div>
        <p className="text-center mt-4">Jericson Lucto</p>
      </div>
    </div>
  );
};

export default DonateModal;